import { axisBottom, axisLeft } from 'd3-axis';
import { scaleLinear } from 'd3-scale';

export function createBase({
  margin,
  container,
  width,
  height,
  x = scaleLinear(),
  y = scaleLinear(),
  xAxis = axisBottom(),
  yAxis = axisLeft(),
  title = '',
}) {
  margin = Object.assign({ top: 20, right: 20, bottom: 20, left: 20 }, margin);

  const parent = container.node();

  const containerWidth = width || parent.offsetWidth;
  const containerHeight = height || parent.offsetHeight;

  const innerWidth = containerWidth - margin.left - margin.right;
  const innerHeight = containerHeight - margin.top - margin.bottom;

  const svg = container
    .append('svg')
    .attr('role', 'graphics-document document')
    .attr('width', containerWidth)
    .attr('height', containerHeight);

  if (title) {
    const titleId = `${container.attr('id')}-title`;
    svg.append('title').attr('id', titleId).text(title);
    svg.attr('aria-labelledby', titleId);
  }

  const g = svg
    .append('g')
    .attr('transform', `translate(${margin.left},${margin.top})`);

  const xScale = x.range([0, innerWidth]);
  const yScale = y.range([innerHeight, 0]);

  xAxis.scale(xScale);
  yAxis.scale(yScale);

  const drawAxis = () => {
    const axes = g
      .append('g')
      .attr('class', 'axes')
      .attr('role', 'graphics-object');

    const xAxisSel = axes
      .append('g')
      .attr('class', 'axis axis--x')
      .attr('role', 'graphics-object')
      .attr('transform', `translate(0,${innerHeight})`)
      .call(xAxis)
      .call((g) => g.selectAll('.tick').attr('role', 'graphics-symbol'));

    const yAxisSel = axes
      .append('g')
      .attr('class', 'axis axis--y')
      .attr('role', 'graphics-object')
      .call(yAxis)
      .call((g) => g.selectAll('.tick').attr('role', 'graphics-symbol'));

    axes.selectAll('.domain').remove();

    return { xAxisSel, yAxisSel };
  };

  return {
    margin,
    container,
    containerWidth,
    containerHeight,
    width: innerWidth,
    height: innerHeight,
    svg,
    g,
    x: xScale,
    y: yScale,
    xAxis,
    yAxis,
    drawAxis,
  };
}
